const BlogItem = (props) => {
    const {
        name, link, photo, date
    } = props;

    return `
        <a class="blog-item" href="${link}">
            <div class="blog-item__image" style="background-image: url('${photo}')"></div>
            <div class="blog-item__title">${name}</div>
        <div class="blog-item__date">${date}</div>
        </a
    `;
};

export default BlogItem;
